import React, { useEffect, useState } from "react";
import { Modal, Spin, Drawer } from "antd";
import { ControlOutlined } from "@ant-design/icons";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import Sidebar from "./Components/Sidebar";
import Map from "./Components/Map";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function EligibilityCheck() {
  const [mapZoomLevel, setMapZoomLevel] = useState(4.5);
  const [mapViewBounds, setMapViewBounds] = useState({
    _sw: { lng: -95.6, lat: 30.3 },
    _ne: { lng: -89.1, lat: 41.3 },
  });
  const [forceZoomToCounty, setForceZoomToCounty] = useState(false);
  const [userLocation, setUserLocation] = useState({});
  const [pinCenter, setPinCenter] = useState(null);
  const [fieldBoundary, setFieldBoundary] = useState(null);
  const [selectedField, setSelectedField] = useState(null);
  const [drawingMode, setDrawingMode] = useState(false);
  const [editingMode, setEditingMode] = useState(false);
  const [pinningMode, setPinningMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mapIsReady, setMapIsReady] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const { selectedCounty, selectedState } = useSelector(
    (state) => state.filter
  );

  useEffect(() => {
    document.body.classList.add("eligibility-check");
    return () => {
      document.body.classList.remove("eligibility-check");
    };
  }, []);

  useEffect(() => {
    console.log("NON GEO CHECK");
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1000);
    };
    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />

      <Modal
        className="filter-modal"
        width="60vw"
        centered={true}
        open={false}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        closable={false}
        footer={
          <button className="regular-button" onClick={() => navigate(-1)}>
            Back
          </button>
        }
      >
        <div className="bandaid-container">
          <h1>Stay Tuned!</h1>
          <div className="bandaid-inner">
            <p>
              The CRP Menu Tool does not currently support your device's size,
              but this feature is currently in development, so check back soon.
            </p>
          </div>
        </div>
      </Modal>
      <div className="eligibility-wrapper">
        {(loading || !mapIsReady) && (
          <Spin className="spinner" tip="Loading" size="large" />
        )}

        <div className="sidebar-wrapper">
          {!isMobile && (
            <Sidebar
              mapZoomLevel={mapZoomLevel}
              mapViewBounds={mapViewBounds}
              setForceZoomToCounty={setForceZoomToCounty}
              userLocation={userLocation}
              setUserLocation={setUserLocation}
              pinCenter={pinCenter}
              setPinCenter={setPinCenter}
              setFieldBoundary={setFieldBoundary}
              selectedField={selectedField}
              setSelectedField={setSelectedField}
              setDrawingMode={setDrawingMode}
              editingMode={editingMode}
              setEditingMode={setEditingMode}
              setPinningMode={setPinningMode}
              setLoading={setLoading}
            />
          )}
        </div>
        <div className="map-wrapper">
          <Map
            setMapZoomLevel={setMapZoomLevel}
            setMapViewBounds={setMapViewBounds}
            setForceZoomToCounty={setForceZoomToCounty}
            forceZoomToCounty={forceZoomToCounty}
            userLocation={userLocation}
            pinCenter={pinCenter}
            setPinCenter={setPinCenter}
            fieldBoundary={fieldBoundary}
            selectedField={selectedField}
            setSelectedField={setSelectedField}
            drawingMode={drawingMode}
            editingMode={editingMode}
            pinningMode={pinningMode}
            onMapReady={() => setMapIsReady(true)}
          />
          {/* Mobile-only gear button */}
          {isMobile && (
            <button
              className={`gear-fab ${
                !selectedState || !selectedCounty ? "bounce" : ""
              }`}
              aria-label="Open options"
              onClick={() => setDrawerOpen(true)}
            >
              <ControlOutlined /> Options
            </button>
          )}
        </div>
      </div>

      {/* Mobile Drawer that contains the Sidebar as a bottom sheet */}
      {isMobile && (
        <Drawer
          className="sidebar-drawer"
          placement="bottom"
          height="auto"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          title="Filters & Tools"
          destroyOnClose={false}
          forceRender
          maskClosable
        >
          <Sidebar
            mapZoomLevel={mapZoomLevel}
            mapViewBounds={mapViewBounds}
            setForceZoomToCounty={setForceZoomToCounty}
            userLocation={userLocation}
            setUserLocation={setUserLocation}
            pinCenter={pinCenter}
            setPinCenter={setPinCenter}
            setFieldBoundary={setFieldBoundary}
            selectedField={selectedField}
            setSelectedField={setSelectedField}
            setDrawingMode={setDrawingMode}
            editingMode={editingMode}
            setEditingMode={setEditingMode}
            setPinningMode={setPinningMode}
            setLoading={setLoading}
            setDrawerOpen={setDrawerOpen}
          />
        </Drawer>
      )}
      <Footer />
    </>
  );
}

export default EligibilityCheck;
